export class SaasAppCost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "usedSeats",
            "baseName": "usedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "committedSeats",
            "baseName": "committedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storedBytes",
            "baseName": "storedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "allowanceBytes",
            "baseName": "allowanceBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "seatCost",
            "baseName": "seatCost",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalCost",
            "baseName": "totalCost",
            "type": "number",
            "format": ""
        },
        {
            "name": "pricePerSeat",
            "baseName": "pricePerSeat",
            "type": "number",
            "format": ""
        },
        {
            "name": "pricePerGbMonth",
            "baseName": "pricePerGbMonth",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasAppCost.attributeTypeMap;
    }
    constructor() {
    }
}
